export default {
  name: 'AnalyticsPostCardFooter',

  props: {
    metrics: {
      default: null,
    },
    /**
     * Data to Show should be (In order):
     * publishDate, time, totalEngagements, peopleReached, impressions, totalClicks, engagementRate, likes, comments, saved, shares,
     */

    dataToShow: {
      required: true,
      type: Array,
    },
  },

  computed: {
    avatar() {
      if (this.dataToShow.includes('avatar')) {
        const avatarUrl =
          this.metrics?.avatar ??
          this.metrics?.avatarUrl ??
          this.metrics?.metrics?.avatar ??
          this.metrics?.metrics?.avatarUrl;

        return avatarUrl;
      }
    },
    audienceMetricTitle() {
      if (!this.metrics?.usesMediaViews) {
        return 'Post Reach';
      }

      return this.showsUniqueViews ? 'Views (Unique)' : 'Views';
    },
    audienceMetricValue() {
      if (!this.metrics?.usesMediaViews) {
        return this.getValue('reach') || this.getValue('impressions');
      }

      return this.showsUniqueViews
        ? this.getValue('uniqueViews')
        : this.getValue('views');
    },
    showsAudienceMetric() {
      if (!this.metrics?.usesMediaViews) {
        return true;
      }

      return this.showsUniqueViews || this.showsViews;
    },
    showsUniqueViews() {
      return (
        this.metrics?.hasUniqueViewsMetric ??
        this.metrics?.usesMediaViews ??
        false
      );
    },
    showsViews() {
      return this.metrics?.hasViewsMetric ?? this.metrics?.usesMediaViews;
    },
    showEngagementRate() {
      if (!this.dataToShow.includes('engagementRate')) {
        return false;
      }

      return (
        this.metrics?.__typename !== 'FacebookMetric' ||
        this.metrics?.hasEngagedUsersMetric
      );
    },
  },

  methods: {
    getValue(name) {
      const value = this.metrics[name] ?? 0;

      if (value) {
        return this.$filters.formatNumber(value);
      }

      return 0;
    },
  },
};
